<template>
  <content-panel class="main">
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" :model="searchForm" ref="searchForm" label-position="left" label-width="90px" size="mini">
          <el-form-item label="导出日期：" prop="exportDate">
             <q-date-picker startFiled="startDate" endFiled="endDate" v-model="searchForm" ref="dateRef" />
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel class="tab-content">
      <export-task ref="exportTask"></export-task>
    </table-panel>
  </content-panel>
</template>

<script>
export default {
  name: 'ExportFile',
  data() {
    return {
      searchForm: {
        startDate: "",
        endDate: "",
      }
    }
  },
  methods: {
    onSearch() {
      const formData = this.$refs['exportTask'].setSearchForm(this.searchForm);
      this.$refs['exportTask'].init(formData);
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.searchForm.startDate = ''
      this.searchForm.endDate = ''
      this.$refs.dateRef.reset()
      this.onSearch();
    },
  },
  mounted() {
    this.onSearch();
  }
}
</script>

<style lang="stylus" scoped>
.tab-content
  >>> .table-panel-content
    height calc(100vh - 140px)
.main
  >>> .main-area
    padding 0
.input-date
  width 250px !important
</style>
<style lang="stylus">
.table-panel-content
  .root
    .el-container
      .page-header
        display none
      .table-main
        padding 0
    .main-weapper
      height 95%
    .el-table
      height calc(100% - 40px) !important
</style>